import { Icon } from 'antd';
import * as React from 'react';
import withTestId from '../e2e/TestId';

const MenuSvg = (props) => (
  <svg width="24px" height="24px" {...props.styles}>
    <title>Menu</title>
    <g id="Menu" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group-8" transform="translate(2.000000, 2.000000)" fill="#333333">
            <rect id="Rectangle" x="0" y="0" width="5.45454545" height="5.45454545"></rect>
            <rect id="Rectangle-Copy-44" x="0" y="7.27272727" width="5.45454545" height="5.45454545"></rect>
            <rect id="Rectangle-Copy-32" x="7.27272727" y="0" width="5.45454545" height="5.45454545"></rect>
            <rect id="Rectangle-Copy-45" x="7.27272727" y="7.27272727" width="5.45454545" height="5.45454545"></rect>
            <rect id="Rectangle-Copy-43" x="14.5454545" y="0" width="5.45454545" height="5.45454545"></rect>
            <rect id="Rectangle-Copy-46" x="14.5454545" y="7.27272727" width="5.45454545" height="5.45454545"></rect>
            <rect id="Rectangle-Copy-49" x="0" y="14.5454545" width="5.45454545" height="5.45454545"></rect>
            <rect id="Rectangle-Copy-48" x="7.27272727" y="14.5454545" width="5.45454545" height="5.45454545"></rect>
            <rect id="Rectangle-Copy-47" x="14.5454545" y="14.5454545" width="5.45454545" height="5.45454545"></rect>
        </g>
    </g>
</svg>);


const MenuIcon = props => (
    <Icon component={innerProps => MenuSvg(Object.assign({}, innerProps, props))} {...props} />
);

export default withTestId(MenuIcon, 'menuicon');
